const NOTO_SC_HREF =
  'https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;600;700&display=swap';

/** Noto Sans SC is several MB: load it only when the UI language is zh. */
export function ensureChineseFont(doc: Document = document): void {
  if (doc.querySelector('link[data-font="noto-sc"]')) return;
  const link = doc.createElement('link');
  link.rel = 'stylesheet';
  link.href = NOTO_SC_HREF;
  link.dataset.font = 'noto-sc';
  doc.head.appendChild(link);
}
